<template>
  <div class="ProjectOverview">
    <CommonHeader :title="currentProject.title" />

    <main v-if="!loading" class="main" :class="$route.name == 'ProjectOverview' ? 'hideWeb' : ''">
      <div class="back-button">
        <router-link style="" :title="$t('Back')" :to="{ name: 'ProjectOverview' }">
          <button class="back-btn pure-material-button-contained">
            <img style="width: auto" src="static/back.png" />
          </button>
        </router-link>
      </div>
      <aside>
        <div class="ProjectOverview-header">
          <h1>{{ currentProject.projectNumber }}</h1>
          <h1>{{ currentProject.title }}</h1>
          <h5 v-if="currentProject.address">
            {{ currentProject.address.street }}, {{ currentProject.address.zipCode }} {{ currentProject.address.city }}.
          </h5>
        </div>
        <ul class="links" v-if="currentProject.links">
          <li v-if="hasSimplePermissions('fetchCompanies')">
            <router-link :title="$t('Contact List')" :to="{ name: 'ViewProjectContacts' }">
              <img src="static/icon/contact.png" />
              {{ $t('Contact List') }}
            </router-link>
          </li>
          <li>
            <router-link :title="$t('Write diary')" :to="{ name: 'Diary', params: { _id: $route.params._id } }">
              <img src="static/icon/diary.png" />
              {{ $t('Write diary') }}
            </router-link>
          </li>
          <li v-if="currentProject.links.workEnvironmentPlan !== ''">
            <a
              target="_blank"
              :title="$t('Open Work Environment Plan')"
              :href="currentProject.links.workEnvironmentPlan"
            >
              <!-- <bookOpenPageVariant-Icon /> -->
              <img src="static/icon/amp.png" />
              {{ $t('Work Environment Plan') }}
            </a>
          </li>
          <li v-if="currentProject.links.selfMonitoring !== ''">
            <a target="_blank" :title="$t('Self-Inspection')" :href="currentProject.links.selfMonitoring">
              <!-- <leadPencil-Icon /> -->
              <img src="static/icon/selfcheck.png" />
              {{ $t('Self-Inspection') }}
            </a>
          </li>
          <li v-if="currentProject.links.projectDescription !== ''">
            <a target="_blank" :title="$t('Project Description')" :href="currentProject.links.projectDescription">
              <!-- <map-Icon /> -->
              <img src="static/icon/description.png" />
              {{ $t('Project Description') }}
            </a>
          </li>
          <li v-if="currentProject.links.qualityDocument !== ''">
            <a target="_blank" :title="$t('Quality Document')" :href="currentProject.links.qualityDocument">
              <!-- <anchor-Icon /> -->
              <img src="static/icon/quality-doc.png" />
              {{ $t('Quality Document') }}
            </a>
          </li>
          <li v-if="currentProject.links.environmentalPlan !== ''">
            <a target="_blank" :title="$t('Environmental Plan')" :href="currentProject.links.environmentalPlan">
              <!-- <pineTree-Icon /> -->
              <img src="static/icon/enviromental-plan.png" />
              {{ $t('Environmental Plan') }}
            </a>
          </li>
          <li
            :class="{ sectionActive: $route.meta.section == 'ProjectSettings' }"
            v-if="hasSimplePermissions('fetchCompanies')"
          >
            <router-link :to="{ name: 'EditProject', params: { _id: $route.params._id } }">
              <img src="static/icon/setup.png" />
              {{ $t('Project Setup') }}
            </router-link>
            <router-link
              v-if="$route.params._id === 'standard'"
              class="submenu"
              :to="{ name: 'EditTodoTemplates', params: { _id: $route.params._id } }"
            >
              {{ $t('Edit Todo Item Templates') }}
            </router-link>
            <router-link
              v-if="$route.params._id === 'standard'"
              class="submenu"
              :to="{ name: 'EditInspectionTemplates', params: { _id: $route.params._id } }"
            >
              {{ $t('Edit Inspection Templates') }}
            </router-link>
            <router-link
              class="submenu"
              v-if="hasSimplePermissions('getProjectLog')"
              :to="{ name: 'ProjectLog', params: { _id: $route.params._id } }"
            >
              {{ $t('View Project Log') }}
            </router-link>
          </li>
          <li :class="{ sectionActive: $route.name == 'ProjectOverview' }">
            <router-link :to="{ name: 'ProjectActionPlan', params: { _id: $route.params._id } }">
              <img src="static/icon/actionlist.png" />
              {{ $t('Action Plan') }}
            </router-link>
          </li>
          <li class="projectPlan">
            <router-link
              :to="{ name: 'ProjectPlanEdit', params: { _id: $route.params._id } }"
              id="viewProjectPlanButton"
            >
              <img src="static/icon/schedule.png" />
              {{ $t('View Project Plan') }}
            </router-link>
          </li>
        </ul>
      </aside>
      <div class="childview">
        <transition name="fade">
          <router-view />
        </transition>
      </div>
    </main>
    <main class="phone-main" v-if="$route.name === 'ProjectOverview'">
      <transition name="fade">
        <div class="project">
          <div class="project-icon">
            <img
              :src="
                currentProject.projectIcon
                  ? currentProject.projectIcon
                  : 'https://boon.h2entreprenad.se/icons/icon_noname.jpg'
              "
            />
          </div>
          <ul class="overview-icon" v-if="currentProject.links">
            <li class="item">
              <router-link :title="$t('Action Plan')" :to="{ name: 'ProjectActionPlan' }">
                <div class="icon">
                  <img src="static/icon/actionlist.png" />
                  <div v-if="myAlertParts.length" class="badge">{{ myAlertParts.length }}</div>
                </div>
                {{ $t('Action Plan') }}
              </router-link>
            </li>
            <li class="item">
              <router-link :title="$t('Contact List')" :to="{ name: 'ViewProjectContacts' }">
                <div class="icon">
                  <img src="static/icon/actionlist.png" />
                </div>
                {{ $t('Contact List') }}
              </router-link>
            </li>
            <li class="item">
              <router-link :title="$t('Write diary')" :to="{ name: 'Diary', params: { _id: $route.params._id } }">
                <div class="icon">
                  <img src="static/icon/diary.png" />
                </div>
                {{ $t('Write diary') }}
              </router-link>
            </li>
            <li class="item">
              <a
                target="_blank"
                :title="$t('Open Work Environment Plan')"
                :href="currentProject.links.workEnvironmentPlan"
              >
                <div class="icon">
                  <img src="static/icon/amp.png" />
                </div>
                {{ $t('Work Environment Plan') }}
              </a>
            </li>

            <li class="item">
              <a target="_blank" :title="$t('Self-Inspection')" :href="currentProject.links.selfMonitoring">
                <div class="icon">
                  <img src="static/icon/selfcheck.png" />
                </div>
                {{ $t('Self-Inspection') }}
              </a>
            </li>
            <li class="item">
              <a target="_blank" :title="$t('Inspections')" :href="currentProject.links.selfMonitoring">
                <div class="icon">
                  <img src="static/icon/round.png" />
                  <div class="badge red">!</div>
                </div>
                {{ $t('Inspections') }}
              </a>
            </li>
            <li class="item">
              <router-link :to="{ name: 'EditProject', params: { _id: $route.params._id } }">
                <div class="icon">
                  <!-- <b-icon icon="gear-fill" /> -->
                  <img src="static/icon/setup.png" />
                </div>
                {{ $t('Installation') }}
              </router-link>
            </li>
            <li class="item">
              <a target="_blank" :title="$t('Quality Document')" :href="currentProject.links.qualityDocument">
                <div class="icon">
                  <img src="static/icon/quality-doc.png" />
                </div>
                {{ $t('Quality Document') }}
              </a>
            </li>
            <li class="item">
              <a target="_blank" :title="$t('Environmental Plan')" :href="currentProject.links.environmentalPlan">
                <div class="icon">
                  <img src="static/icon/enviromental-plan.png" />
                </div>
                {{ $t('Environmental Plan') }}
              </a>
            </li>
          </ul>
          <div class="back-button">
            <router-link :to="{ name: 'ProjectList' }">
              <button class="back-btn pure-material-button-contained">
                <img style="width: auto" src="static/back.png" />
              </button>
            </router-link>
          </div>
        </div>
      </transition>
    </main>
    <CommonFooter />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import CommonHeader from '@/components/toolbar/CommonHeader';
import CommonFooter from '@/components/toolbar/CommonFooter';

export default {
  name: 'ProjectOverview',

  components: { CommonFooter, CommonHeader },

  data() {
    return {
      loading: true,
    };
  },

  methods: {
    ...mapActions(['loadProject', 'closeAllTopLevelStages', 'selectPart']),
  },

  computed: {
    ...mapGetters(['currentProject', 'hasSimplePermissions', 'myAlertParts', 'isDebugMode']),
  },

  watch: {
    $route: {
      immediate: true,
      async handler(next, prev) {
        if (!next || !prev || next.params._id !== prev.params._id) {
          this.loading = false;
          try {
            this.selectPart(null);
            await this.loadProject(next && next.params._id);
            this.closeAllTopLevelStages();
          } finally {
            this.loading = false;
          }
        }
      },
    },
  },
};
</script>

<style scoped>
main {
  display: flex;
  flex-flow: row nowrap;
}

aside {
  /* background-color: #0F161E; */
  position: relative;
}

@media (max-width: 768px) {
  .ProjectOverview .links {
    width: 15em !important;
  }
}

.ProjectOverview-header {
  width: 100%;
  padding: 20px;
}

.ProjectOverview-header h1 {
  font-size: 2em;
  padding-bottom: 10px;
}

.ProjectOverview-header h5 {
  font-size: 1rem;
  font-weight: 300;
}

.menu {
  border-bottom: 2px solid white;
  font-size: 20px;
  width: 70%;
  margin-top: 30px;
}

.links {
  width: 20em;
  padding-left: 0;
}

.links li {
  display: flex;
  align-items: flex-start;
  padding: 20px 5px;
  padding-left: 20px;
  border-bottom: 2px solid #1c2731;
  transition: all ease 0.3s;
  letter-spacing: 1px;
  font-size: 0.875em;
  flex-direction: column;
}

.links li:hover {
  background: #e8963a;
}

.links li.projectPlan {
  font-size: 1em;
}

li.sectionActive {
  background-color: #1c2731;
}

li.sectionActive > .submenu {
  height: 20px;
  display: block;
}

li:hover > a.submenu {
  transition: all ease 0.3s;
  height: 20px !important;
  transition-delay: 0.5s;
}

.links .submenu {
  overflow: hidden;
  transition: all ease 0.3s;
  display: block;
  height: 0px;
  padding: 0px 55px;
  font-size: 0.8em;
  border-bottom: 0;
  letter-spacing: 1px;
  width: 100%;
}

.submenu:before {
  content: '> ';
}

.links li.submenu:hover {
  background: transparent;
  color: #e8963a;
}

.phone-main {
  display: none;
}

.childview {
  overflow-y: auto;
  border: 0px solid white;
  background-color: #1c2731;
  width: 100%;
}

.back-btn {
  width: 50px;
  /* background: green; */
  /* background-image: linear-gradient(to right bottom, #DE8F45, #BC4F51); */
  height: 50px;
  text-transform: uppercase;
  border-radius: 100%;
  font-size: 20px;
  display: flex;
  justify-content: space-evenly;
  font-weight: 500;
}

.back-button {
  display: none;
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 10000;
  cursor: pointer;
}

@media (max-width: 767px) {
  .main.hideWeb {
    display: none;
  }
  aside {
    display: none;
  }

  .phone-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('/static/1.jpg') no-repeat center;
    min-height: 100vh;
  }

  .phone-main .project {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    position: relative;
  }

  .project-icon {
    overflow: hidden;
    width: 200px;
    height: 200px;
    /* border: 5px solid #151C30; */
    display: inline-flex;
    border-radius: 100%;
    box-sizing: border-box;
    background: linear-gradient(to right, #151d30, #223c64);
    margin-top: 100px;
  }

  .project-icon img {
    object-fit: cover;
    min-width: 200px;
    min-height: 200px;
    border-radius: 100%;
    padding: 5px;
  }

  .phone-main .overview-icon {
    display: flex;
    margin-top: 50px;
    flex-flow: wrap;
    justify-content: start;
    width: 90%;
    list-style: none;
  }

  .phone-main .overview-icon .item {
    width: 33%;
    text-align: center;
    margin-bottom: 30px;
    /* color: #a0aaba; */
    font-size: 14px;
  }

  .phone-main .overview-icon .item a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone-main .overview-icon .item .icon {
    /* border: 1px solid #a0aaba; */
    border-radius: 100%;
    /* padding: 5px !important; */
    margin-bottom: 15px;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .phone-main .overview-icon .item .icon i {
    color: #a0aaba;
    font-size: 22px;
    transform: none;
  }

  .phone-main .overview-icon p {
    color: #a0aaba;
  }
  .phone-main .overview-icon .item .badge {
    position: absolute;
    top: -10px;
    right: -15px;
    background: #d98219;
    padding: 5px;
    border-radius: 100%;
    font-size: 12px;
    color: #000;
    font-weight: 600;
    height: 25px;
    width: 25px;
  }
  .phone-main .overview-icon .item .badge.red {
    background: #ee4930;
  }

  .back-button img {
    width: 40px;
  }
  .back-button {
    display: block;
  }
}

@media (max-width: 640px) {
  .phone-main .overview-icon {
    justify-content: space-around;
  }

  .phone-main .overview-icon .item {
    width: 33%;
  }
}

@media (max-width: 459px) {
  .phone-main .project-icon {
    margin-top: 100px;
  }

  .phone-main .overview-icon {
    /* justify-content: space-between; */
  }

  .phone-main .overview-icon .item {
    font-size: 10px;
  }
}

@media (max-width: 320px) {
  .phone-main .project-icon {
    margin-top: 80px;
  }

  .project-icon {
    width: 160px;
    height: 160px;
  }

  .phone-main .overview-icon {
    width: 100%;
  }

  .phone-main .overview-icon .item {
    font-size: 10px;
    font-weight: 300;
    margin-bottom: 20px;
  }

  .project-icon img {
    min-width: 160px;
    min-height: 160px;
  }

  .phone-main .overview-icon .item {
    width: 31%;
  }

  .phone-main .overview-icon {
    justify-content: center;
  }
}

@media print {
  .childview {
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projectoverview/ProjectOverview.vue